export const addDashesToSocial = (val: string) =>
  val.split('').map((char, i) => ([2, 4].includes(i) ? `${char}-` : char))
